var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    [
      _c("mini-header", {
        attrs: {
          list: _vm.status,
          filter: _vm.filter,
          status: _vm.status,
          breadcrumbs: _vm.breadcrumbs,
          hiddenTab: true,
          dense: true,
          scroll: _vm.scroll,
          iconAllTab: "mdi-printer-pos",
        },
        on: {
          "update:filter": function ($event) {
            _vm.filter = $event
          },
        },
        scopedSlots: _vm._u([
          {
            key: "main",
            fn: function () {
              return [
                _c("v-query-builder", {
                  staticClass: "ml-2",
                  attrs: {
                    "query-map": _vm.filters,
                    model: "pos",
                    active: _vm.activeFilter,
                  },
                  on: {
                    "update:active": function ($event) {
                      _vm.activeFilter = $event
                    },
                  },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "grey-700",
            fn: function () {
              return [
                _c(
                  "v-btn",
                  {
                    staticClass: "ml-2",
                    attrs: { width: "35", outlined: "" },
                    on: {
                      click: function ($event) {
                        _vm.mode = !_vm.mode
                      },
                    },
                  },
                  [
                    _c("v-icon", { attrs: { size: "19" } }, [
                      _vm._v(
                        "mdi-" +
                          _vm._s(_vm.mode ? "view-grid-outline" : "table")
                      ),
                    ]),
                  ],
                  1
                ),
                [
                  _vm.mode
                    ? _c(
                        "v-menu",
                        {
                          attrs: {
                            "close-on-click": "",
                            "close-on-content-click": "",
                            "offset-y": "",
                            left: "",
                            "nudge-bottom": 10,
                            transition: "slide-y-transition",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function ({ on, attrs }) {
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            staticClass: "ml-2",
                                            attrs: { outlined: "" },
                                          },
                                          "v-btn",
                                          attrs,
                                          false
                                        ),
                                        on
                                      ),
                                      [
                                        _c("v-icon", { attrs: { left: "" } }, [
                                          _vm._v("mdi-checkbox-outline "),
                                        ]),
                                        _vm._v("Selecciona"),
                                        _c(
                                          "v-icon",
                                          { attrs: { size: "18", right: "" } },
                                          [_vm._v("mdi-chevron-down")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1526562019
                          ),
                        },
                        [
                          _c(
                            "v-list",
                            { staticClass: "pa-0" },
                            [
                              _c(
                                "v-list-item",
                                {
                                  staticClass: "px-3",
                                  attrs: { ripple: false },
                                  on: {
                                    click: function ($event) {
                                      _vm.actionSelected = "todos"
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-list-item-title",
                                    { staticClass: "body-2 grey-500--text" },
                                    [_vm._v("Todos")]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-list-item",
                                {
                                  staticClass: "px-3",
                                  attrs: { ripple: false },
                                  on: {
                                    click: function ($event) {
                                      _vm.actionSelected = "filtrados"
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-list-item-title",
                                    { staticClass: "body-2 grey-500--text" },
                                    [_vm._v("Filtrados")]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-list-item",
                                {
                                  staticClass: "px-3",
                                  attrs: { ripple: false },
                                  on: {
                                    click: function ($event) {
                                      _vm.actionSelected = "primera página"
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-list-item-title",
                                    { staticClass: "body-2 grey-500--text" },
                                    [_vm._v("Primera página")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "v-menu",
                    {
                      attrs: {
                        "close-on-click": "",
                        "close-on-content-click": "",
                        "offset-y": "",
                        left: "",
                        "nudge-bottom": 10,
                        transition: "slide-y-transition",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function ({ on, attrs }) {
                            return [
                              _c(
                                "v-btn",
                                _vm._g(
                                  _vm._b(
                                    {
                                      staticClass: "ml-2",
                                      attrs: { outlined: "" },
                                    },
                                    "v-btn",
                                    attrs,
                                    false
                                  ),
                                  on
                                ),
                                [
                                  _c("v-icon", { attrs: { left: "" } }, [
                                    _vm._v("mdi-plus-box "),
                                  ]),
                                  _vm._v("Opciones"),
                                  _c(
                                    "v-icon",
                                    { attrs: { size: "18", right: "" } },
                                    [_vm._v("mdi-chevron-down")]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c(
                        "v-list",
                        { staticClass: "pa-0" },
                        [
                          _c(
                            "v-list-item",
                            {
                              staticClass: "px-3",
                              attrs: {
                                ripple: false,
                                disabled: !_vm.selectedList.length,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleGroup("create")
                                },
                              },
                            },
                            [
                              _c(
                                "v-list-item-title",
                                { staticClass: "body-2 grey-500--text" },
                                [_vm._v("Crear grupo")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-list-item",
                            {
                              staticClass: "px-3",
                              attrs: {
                                ripple: false,
                                disabled: !_vm.selectedList.length,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleGroup("add")
                                },
                              },
                            },
                            [
                              _c(
                                "v-list-item-title",
                                { staticClass: "body-2 grey-500--text" },
                                [_vm._v("Agregar grupo")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("v-query-builder", {
                    staticClass: "ml-2",
                    attrs: {
                      "query-map": _vm.filters,
                      model: "pos",
                      disabled: _vm.count === 0,
                    },
                  }),
                ],
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "v-col",
        { staticClass: "px-0" },
        [
          _vm.loading
            ? _c("VSkeleton")
            : [
                !_vm.posList?.length ||
                Object.keys(_vm.$route?.query)?.length === 0
                  ? _c("v-empty-state", {
                      attrs: {
                        type: "pos",
                        id: "pos",
                        customClass: "mt-3",
                        hiddenDescription: _vm.hiddenBtnEmpty,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "actions",
                            fn: function () {
                              return [
                                !_vm.$route.query.ordering && _vm.hiddenBtnEmpty
                                  ? [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            color: "grey-900",
                                            ripple: false,
                                            width: 153,
                                          },
                                          on: {
                                            click: function ($event) {
                                              _vm.activeFilter = true
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { staticClass: "mr-2" },
                                            [_vm._v("mdi-filter-plus")]
                                          ),
                                          _vm._v("Filtrar"),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "ml-2",
                                          attrs: {
                                            outlined: "",
                                            ripple: false,
                                            width: "153",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.latestRecords(
                                                "-created"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { staticClass: "mr-2" },
                                            [_vm._v("mdi-text-search-variant")]
                                          ),
                                          _vm._v("Ver POS"),
                                        ],
                                        1
                                      ),
                                    ]
                                  : _vm._e(),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        1790120548
                      ),
                    })
                  : [
                      _vm.mode
                        ? _c(
                            "v-col",
                            { staticClass: "px-0 pt-0", attrs: { cols: "12" } },
                            [
                              _c("VCardList", {
                                staticClass: "pb-16",
                                attrs: {
                                  list: _vm.posList,
                                  complements: _vm.branchesList,
                                  chipStatus: _vm.chipStatus,
                                  selectedList: _vm.selectedList,
                                  actionSelected: _vm.actionSelected,
                                },
                                on: {
                                  "update:selectedList": function ($event) {
                                    _vm.selectedList = $event
                                  },
                                  "update:selected-list": function ($event) {
                                    _vm.selectedList = $event
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        : [
                            _vm.posList.length
                              ? _c("v-data-table", {
                                  class: {
                                    "fixed-table":
                                      _vm.$store.state.base
                                        .isExpandNavigationDrawer,
                                  },
                                  staticStyle: { cursor: "pointer" },
                                  attrs: {
                                    headers: _vm.headers,
                                    items: _vm.posList,
                                    "items-per-page": _vm.pagination,
                                    "hide-default-header": "",
                                    "disable-sort": "",
                                    "mobile-breakpoint": "",
                                    "hide-default-footer": "",
                                    "item-key": "id",
                                    "show-select": "",
                                    "checkbox-color": "grey-900",
                                    "fixed-header": "",
                                    height: _vm.heightTable,
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "header",
                                        fn: function ({ props: { headers } }) {
                                          return [
                                            _c("VTableHeaders", {
                                              attrs: {
                                                headers: headers,
                                                resetCheckbox:
                                                  _vm.resetCheckbox,
                                              },
                                              on: {
                                                sort: _vm.setSort,
                                                toggleAll: _vm.toggleAll,
                                                isSelected: function ($event) {
                                                  _vm.isSelected = $event
                                                },
                                                toggleDropdown: function (
                                                  $event
                                                ) {
                                                  _vm.toggleDropdown = $event
                                                },
                                              },
                                            }),
                                            _c("v-divider", {
                                              staticStyle: {
                                                position: "absolute",
                                                "margin-top": "-6px",
                                                "margin-left": "-5px",
                                                "z-index": "2",
                                                "min-width": "100%",
                                              },
                                            }),
                                          ]
                                        },
                                      },
                                      {
                                        key: `item.name`,
                                        fn: function ({ item }) {
                                          return [
                                            item.name
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "body-1 mb-n2 d-inline-block text-truncate",
                                                    staticStyle: {
                                                      "max-width": "95%",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s((item || {}).name)
                                                    ),
                                                  ]
                                                )
                                              : _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "body-2 text--disabled font-italic",
                                                  },
                                                  [_vm._v("Sin especificar")]
                                                ),
                                          ]
                                        },
                                      },
                                      {
                                        key: `item.branch`,
                                        fn: function ({ item }) {
                                          return [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "text-decoration-none grey-500--text",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.nameBranch(item.branch)
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: `item.custom_id`,
                                        fn: function ({ item }) {
                                          return [
                                            _c(
                                              "span",
                                              { staticClass: "body-1" },
                                              [
                                                _vm._v(
                                                  _vm._s(item.custom_id || "-")
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: `item.status`,
                                        fn: function ({ item }) {
                                          return [
                                            _c(
                                              "v-chip",
                                              {
                                                attrs: {
                                                  color:
                                                    _vm.chipStatus[item.status]
                                                      .color,
                                                  small: "",
                                                  label: "",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "font-weight-semibold",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.chipStatus[
                                                          item.status
                                                        ].name
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      right: "",
                                                      size: "18",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.chipStatus[
                                                          item.status
                                                        ].icon
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: `item.actions`,
                                        fn: function ({ item }) {
                                          return [
                                            _c(
                                              "v-menu",
                                              {
                                                attrs: {
                                                  "close-on-click": "",
                                                  "close-on-content-click": "",
                                                  "offset-y": "",
                                                  left: "",
                                                  "nudge-bottom": 10,
                                                  "nudge-left": 10,
                                                  transition:
                                                    "slide-y-transition",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function ({
                                                        on,
                                                        attrs,
                                                      }) {
                                                        return [
                                                          _c(
                                                            "v-btn",
                                                            _vm._g(
                                                              _vm._b(
                                                                {
                                                                  staticClass:
                                                                    "mr-n4",
                                                                  attrs: {
                                                                    text: "",
                                                                    "x-small":
                                                                      "",
                                                                  },
                                                                },
                                                                "v-btn",
                                                                attrs,
                                                                false
                                                              ),
                                                              on
                                                            ),
                                                            [
                                                              _c(
                                                                "v-icon",
                                                                {
                                                                  attrs: {
                                                                    color:
                                                                      "grey-500",
                                                                    size: "24",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "mdi-dots-vertical"
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              },
                                              [
                                                _c(
                                                  "v-list",
                                                  { staticClass: "pa-0" },
                                                  [
                                                    _c(
                                                      "v-list-item",
                                                      {
                                                        staticClass: "px-3",
                                                        attrs: {
                                                          ripple: false,
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.hanldeTableAddToGroup(
                                                              item
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-list-item-title",
                                                          {
                                                            staticClass:
                                                              "body-2 grey-500--text",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Agregar a grupo"
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                  model: {
                                    value: _vm.selected,
                                    callback: function ($$v) {
                                      _vm.selected = $$v
                                    },
                                    expression: "selected",
                                  },
                                })
                              : _vm._e(),
                            _vm.posList.length
                              ? _c("VMainPagination", {
                                  attrs: {
                                    titleShowAll: "Ver todos los documentos",
                                    count: _vm.count,
                                    redirect: "purchasesList",
                                  },
                                })
                              : _vm._e(),
                          ],
                    ],
              ],
        ],
        2
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "650",
            persistent: "",
            "no-click-animation": "",
            scrollable: "",
            "overlay-color": "grey-500",
          },
          model: {
            value: _vm.dialogGroup,
            callback: function ($$v) {
              _vm.dialogGroup = $$v
            },
            expression: "dialogGroup",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-toolbar",
                    { attrs: { color: "transparent", flat: "", height: "46" } },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticClass:
                            "px-5 subtitle-2 grey-500--text font-weight-semibold",
                        },
                        [_vm._v("Crear grupo")]
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "mr-3",
                              attrs: { align: "center", justify: "center" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: { icon: "", small: "" },
                                  on: {
                                    click: function ($event) {
                                      _vm.dialogGroup = false
                                    },
                                  },
                                },
                                [
                                  _c("v-icon", { attrs: { size: "24" } }, [
                                    _vm._v("mdi-close"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                {
                  staticClass: "pb-4 pt-6 px-5",
                  staticStyle: { "max-height": "600px !important" },
                },
                [
                  _c(
                    "v-list",
                    { staticClass: "pa-0 transparent v-list-form-extended" },
                    [
                      _c(
                        "v-list-item",
                        { staticClass: "py-1" },
                        [
                          _c("v-list-item-title", [_vm._v("Nombre")]),
                          _c(
                            "v-list-item-subtitle",
                            [
                              _c("v-text-field", {
                                attrs: {
                                  error: _vm.$v.newGroup.name.$error,
                                  outlined: "",
                                  required: "",
                                  "single-line": "",
                                  dense: "",
                                  maxlength: "100",
                                  "hide-details": "",
                                },
                                model: {
                                  value: _vm.$v.newGroup.name.$model,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.$v.newGroup.name,
                                      "$model",
                                      $$v
                                    )
                                  },
                                  expression: "$v.newGroup.name.$model",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-list-item",
                        { staticClass: "py-1" },
                        [
                          _c("v-list-item-title", [_vm._v("Descripción")]),
                          _c(
                            "v-list-item-subtitle",
                            [
                              _c("v-text-field", {
                                attrs: {
                                  error: _vm.$v.newGroup.description.$error,
                                  outlined: "",
                                  required: "",
                                  "single-line": "",
                                  dense: "",
                                  maxlength: "100",
                                  "hide-details": "",
                                },
                                model: {
                                  value: _vm.$v.newGroup.description.$model,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.$v.newGroup.description,
                                      "$model",
                                      $$v
                                    )
                                  },
                                  expression: "$v.newGroup.description.$model",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {},
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "d-block mt-5 body-1 grey-500--text font-weight-bold",
                        },
                        [_vm._v("Visibilidad")]
                      ),
                      _c(
                        "v-radio-group",
                        {
                          staticClass: "mx-0 ml-n1",
                          attrs: { dense: "", "hide-details": "" },
                          model: {
                            value: _vm.newGroup.visibility,
                            callback: function ($$v) {
                              _vm.$set(_vm.newGroup, "visibility", $$v)
                            },
                            expression: "newGroup.visibility",
                          },
                        },
                        [
                          _c("v-radio", {
                            attrs: {
                              label: "Todos los miembros de la organización",
                              value: 1,
                              "hide-details": "",
                            },
                          }),
                          _c("v-radio", {
                            attrs: {
                              label: "Algunos miembros de la organización",
                              value: 2,
                              "hide-details": "",
                            },
                          }),
                          _c("v-radio", {
                            attrs: {
                              label: "Solo yo",
                              value: 3,
                              "hide-details": "",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  ![1, 3].includes(_vm.newGroup.visibility)
                    ? [
                        _c(
                          "v-list",
                          {
                            staticClass:
                              "pa-0 mt-5 transparent v-list-form-extended",
                          },
                          [
                            _c(
                              "v-list-item",
                              { staticClass: "py-1" },
                              [
                                _c("v-list-item-title", [
                                  _vm._v("Compartir con"),
                                ]),
                                _c(
                                  "v-list-item-subtitle",
                                  [
                                    _c(
                                      "v-col",
                                      { staticClass: "pa-0" },
                                      [
                                        _c("v-autocomplete", {
                                          attrs: {
                                            error:
                                              _vm.$v.newGroup.members.$error,
                                            "hide-details": "",
                                            "single-line": "",
                                            color: "grey-900",
                                            dense: "",
                                            outlined: "",
                                            items: _vm.membersList,
                                            multiple: "",
                                            chips: false,
                                            "item-text": "email",
                                            "item-value": "email",
                                            "return-object": "",
                                            "append-icon": "mdi-chevron-down",
                                            prefix:
                                              _vm.newGroup.members.length >= 1
                                                ? `${
                                                    _vm.newGroup.members
                                                      .length === 1
                                                      ? `${_vm.newGroup.members.length} seleccionado`
                                                      : `${_vm.newGroup.members.length} seleccionados`
                                                  }`
                                                : "",
                                            "no-data-text":
                                              "No existen miembros para mostrar",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "selection",
                                                fn: function ({ props }) {
                                                  return [
                                                    props
                                                      ? _c("span", {})
                                                      : _vm._e(),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            1879759739
                                          ),
                                          model: {
                                            value: _vm.newGroup.members,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.newGroup,
                                                "members",
                                                $$v
                                              )
                                            },
                                            expression: "newGroup.members",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          [
                            _c("v-col", { attrs: { cols: "2" } }),
                            _c(
                              "v-col",
                              { staticClass: "pl-9 mt-2" },
                              _vm._l(
                                _vm.newGroup.members,
                                function (member, i) {
                                  return _c(
                                    "v-chip",
                                    {
                                      key: `${member}${i}`,
                                      staticClass:
                                        "mr-2 mb-2 font-weight-light text-lowercase overline chip-users",
                                      attrs: {
                                        color: "lightBlue",
                                        small: "",
                                        label: "",
                                        closable: "",
                                        "close-icon": "mdi-close",
                                      },
                                      on: {
                                        "click:close": function ($event) {
                                          return _vm.memberRemove(member)
                                        },
                                      },
                                    },
                                    [_vm._v(" " + _vm._s(member.email) + " ")]
                                  )
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "px-5 py-2" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { outlined: "" },
                      on: {
                        click: function ($event) {
                          _vm.dialogGroup = false
                        },
                      },
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "grey-900",
                        loading: _vm.createGroupLoading,
                      },
                      on: { click: _vm.createGroup },
                    },
                    [_vm._v("Crear")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "650",
            persistent: "",
            "no-click-animation": "",
            scrollable: "",
            "overlay-color": "grey-500",
          },
          model: {
            value: _vm.dialogAddGroup,
            callback: function ($$v) {
              _vm.dialogAddGroup = $$v
            },
            expression: "dialogAddGroup",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-toolbar",
                    { attrs: { color: "transparent", flat: "", height: "46" } },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticClass:
                            "px-5 subtitle-2 grey-500--text font-weight-semibold",
                        },
                        [_vm._v("Agregar a grupo")]
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "mr-3",
                              attrs: { align: "center", justify: "center" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: { icon: "", small: "" },
                                  on: {
                                    click: function ($event) {
                                      ;(_vm.dialogAddGroup = false),
                                        (_vm.groups = [])
                                    },
                                  },
                                },
                                [
                                  _c("v-icon", { attrs: { size: "24" } }, [
                                    _vm._v("mdi-close"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                {
                  staticClass: "pb-7 pt-5 px-5",
                  staticStyle: { "max-height": "600px !important" },
                },
                [
                  _c(
                    "v-list",
                    {
                      staticClass: "pa-0 mt-5 transparent v-list-form-extended",
                    },
                    [
                      _c(
                        "v-list-item",
                        { staticClass: "py-1" },
                        [
                          _c("v-list-item-title", [_vm._v("Grupo")]),
                          _c(
                            "v-list-item-subtitle",
                            [
                              _c(
                                "v-col",
                                { staticClass: "pa-0" },
                                [
                                  _c("v-autocomplete", {
                                    attrs: {
                                      "hide-details": "",
                                      "single-line": "",
                                      color: "grey-900",
                                      dense: "",
                                      outlined: "",
                                      items: _vm.pos_groupsList,
                                      multiple: "",
                                      chips: false,
                                      "item-text": "name",
                                      "item-value": "id",
                                      "return-object": "",
                                      "append-icon": "mdi-chevron-down",
                                      prefix:
                                        _vm.groups.length >= 1
                                          ? `${
                                              _vm.groups.length === 1
                                                ? `${_vm.groups.length} seleccionado`
                                                : `${_vm.groups.length} seleccionados`
                                            }`
                                          : "",
                                      "no-data-text":
                                        "No existen grupos para mostrar",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "selection",
                                        fn: function ({ props }) {
                                          return [
                                            props ? _c("span", {}) : _vm._e(),
                                          ]
                                        },
                                      },
                                    ]),
                                    model: {
                                      value: _vm.groups,
                                      callback: function ($$v) {
                                        _vm.groups = $$v
                                      },
                                      expression: "groups",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _c("v-col", { attrs: { cols: "2" } }),
                      _c(
                        "v-col",
                        { staticClass: "pl-9 mt-2" },
                        _vm._l(_vm.groups, function (g, i) {
                          return _c(
                            "v-chip",
                            {
                              key: `${g}${i}`,
                              staticClass:
                                "mr-2 mb-2 font-weight-light text-lowercase overline chip-users",
                              attrs: {
                                color: "lightBlue",
                                small: "",
                                label: "",
                                closable: "",
                                "close-icon": "mdi-close",
                              },
                              on: {
                                "click:close": function ($event) {
                                  return _vm.groupsRemove(g)
                                },
                              },
                            },
                            [_vm._v(" " + _vm._s(g.name) + " ")]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "px-5 py-2" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { outlined: "" },
                      on: {
                        click: function ($event) {
                          ;(_vm.dialogAddGroup = false), (_vm.groups = [])
                        },
                      },
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "grey-900",
                        loading: _vm.createGroupLoading,
                      },
                      on: { click: _vm.addToGroup },
                    },
                    [_vm._v("Guardar")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }